// extracted by mini-css-extract-plugin
export default {"gallery":"style_gallery__uDz0-","imageContainer":"style_imageContainer__EpZ-g","vignette":"style_vignette__yglPN"};